// extracted by mini-css-extract-plugin
export default {"menu":"index_menu__P3y1F","center":"index_center__4zJGi"};